import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { PayloadAction } from '@reduxjs/toolkit';
import { UserId } from 'features/users/types';

export function* askUnmuteRemoteVideoSaga(action: PayloadAction<UserId>) {
  yield call(SignalingSocket.send, {
    event: 'askToUnmuteRemoteVideo',
    data: {
      id: action.payload,
    },
  });
}
